export default __webpack_public_path__ + "afbb0d80ab3facf0bb9618dd15daa431.png";